module.exports = __webpack_public_path__ + "static/media/ic_cold_water.755f7925.png";